import { useMediaQuery } from '@mui/system'
import CookiesStorageService from '../../../services/CookiesStorageService'
import SingleSectionContainer from './helpers/SingleSectionContainer'
import SingleInfo from './helpers/SingleInfo'
import SingleRole from './helpers/SingleRole'
import UseTranslation from '../../../hooks/UseTranslation'
import HoverTooltip from '../../../components/PageHelpers/HoverTooltip'
import { getUserName } from '../../../utils/helpers'

const Index = () => {
  const { t } = UseTranslation()
  const userName = CookiesStorageService.getUserName()
  const userEmail = CookiesStorageService.getUserEmail()
  const isSmScreen = useMediaQuery((theme) => theme.breakpoints.down('lg'))

  const isAdmin = CookiesStorageService.getAdminType() === 'sys_admin'
  return (
  <>
    <SingleSectionContainer sectionTitle={t?.['Basic Information']} customStyle={styles.basicInformation}>
      <SingleInfo
      title={t?.['Full Name']}
      info={
        <HoverTooltip title={userName}>
          {getUserName(userName, isSmScreen)}
        </HoverTooltip>
        }
        customStyle={styles.fullName}
      />
      <SingleInfo title={t?.['Email Address']}
        info={
          <HoverTooltip title={userEmail}>
            {`${userEmail?.slice(0, 30)} ${userEmail?.length > 30 ? '...' : ''}`}
          </HoverTooltip>
        }
        customStyle={styles.emailAddress}
      />
    </SingleSectionContainer>
    {!isAdmin && (
    <SingleSectionContainer sectionTitle={t?.['Role Information']} customStyle={styles.roleInformation}>
      {CookiesStorageService.getEdsRoles()?.length > 0 &&
        <SingleRole title={`- ${t?.Eds}`} roles={CookiesStorageService.getEdsRoles()} customStyle={styles.roleItem} />}
      {CookiesStorageService.getRecRoles()?.length > 0 &&
        <SingleRole title={`- ${t?.Recruitment}`} roles={CookiesStorageService.getRecRoles()} customStyle={styles.roleItem} />}
      {CookiesStorageService.getSelfRoles()?.length > 0 &&
        <SingleRole title='- Self' roles={CookiesStorageService.getSelfRoles()} customStyle={styles.roleItem} />}
      {CookiesStorageService.getFabsRoles()?.length > 0 &&
        <SingleRole title='- Core' roles={CookiesStorageService.getFabsRoles()} customStyle={styles.roleItem} />}
    </SingleSectionContainer>
    )}
  </>
  )
}

const styles = {
  basicInformation: {
    backgroundColor: '#F5F5F5',
  },
  roleInformation: {
    backgroundColor: '#F5F5F5',
  },
  roleItem: {
    borderBottom: '1px solid #E2E8EE',
    '& .MuiTypography-root': {
      marginTop: '5px',
      marginBottom: '5px',
    },
    '& :last-child': {
      borderBottom: 'none',
    },
  },
  fullName: {
    borderBottom: '1px solid #E2E8EE',
    '& .MuiTypography-root': {
      marginBottom: '10px',
    },
  },
  emailAddress: {
    '& .MuiTypography-root': {
      marginTop: '10px',
    },
  },
}
export default Index
